const AiCompanyInfocardLarge = () => {
  return (
    <>
      <div className="aih-info-card-lg-area ah-bg ptb-60">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-9">
              <div className="text-center">
                <h2 className="aih-title aih-color-two fs-48 fw-600 mb-20">
                  Save Time Managing Your Business With Our Best Services
                </h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-4 col-md-6">
              <div className="aih-info-card-item bgc-white aih-shadow-hover p-4 ptb-30 rounded-10 mt-20">
                <div className="d-flex align-items-center gap-2">
                  <img src="assets/img/ai_home/info_icon_3.svg" alt="" />
                  <h5 className="aih-color-two fs-24 fw-600">UI & UX Design</h5>
                </div>
                <p className="ca-two-body-clr mt-20 mb-0">
                  Energistically transition interoperable resources with
                  principle-centered metrics. Enthusiastically functional
                  process improvements.
                </p>
              </div>
            </div>
            <div className="col-xl-4 col-md-6">
              <div className="aih-info-card-item bgc-white aih-shadow-hover p-4 ptb-30 rounded-10 mt-20">
                <div className="d-flex align-items-center gap-2">
                  <img src="assets/img/ai_home/info_icon_4.svg" alt="" />
                  <h5 className="aih-color-two fs-24 fw-600">
                    Web Development
                  </h5>
                </div>
                <p className="ca-two-body-clr mt-20 mb-0">
                  Energistically transition interoperable resources with
                  principle-centered metrics. Enthusiastically functional
                  process improvements.
                </p>
              </div>
            </div>
            <div className="col-xl-4 col-md-6">
              <div className="aih-info-card-item bgc-white aih-shadow-hover p-4 ptb-30 rounded-10 mt-20">
                <div className="d-flex align-items-center gap-2">
                  <img src="assets/img/ai_home/info_icon_5.svg" alt="" />
                  <h5 className="aih-color-two fs-24 fw-600">
                    Online Marketing
                  </h5>
                </div>
                <p className="ca-two-body-clr mt-20 mb-0">
                  Energistically transition interoperable resources with
                  principle-centered metrics. Enthusiastically functional
                  process improvements.
                </p>
              </div>
            </div>
            <div className="col-xl-4 col-md-6">
              <div className="aih-info-card-item bgc-white aih-shadow-hover p-4 ptb-30 rounded-10 mt-20">
                <div className="d-flex align-items-center gap-2">
                  <img src="assets/img/ai_home/info_icon_6.svg" alt="" />
                  <h5 className="aih-color-two fs-24 fw-600">SEO Marketing</h5>
                </div>
                <p className="ca-two-body-clr mt-20 mb-0">
                  Energistically transition interoperable resources with
                  principle-centered metrics. Enthusiastically functional
                  process improvements.
                </p>
              </div>
            </div>
            <div className="col-xl-4 col-md-6">
              <div className="aih-info-card-item bgc-white aih-shadow-hover p-4 ptb-30 rounded-10 mt-20">
                <div className="d-flex align-items-center gap-2">
                  <img src="assets/img/ai_home/info_icon_7.svg" alt="" />
                  <h5 className="aih-color-two fs-24 fw-600">Technology</h5>
                </div>
                <p className="ca-two-body-clr mt-20 mb-0">
                  Energistically transition interoperable resources with
                  principle-centered metrics. Enthusiastically functional
                  process improvements.
                </p>
              </div>
            </div>
            <div className="col-xl-4 col-md-6">
              <div className="aih-info-card-item bgc-white aih-shadow-hover p-4 ptb-30 rounded-10 mt-20">
                <div className="d-flex align-items-center gap-2">
                  <img src="assets/img/ai_home/info_icon_8.svg" alt="" />
                  <h5 className="aih-color-two fs-24 fw-600">
                    Brand Identities
                  </h5>
                </div>
                <p className="ca-two-body-clr mt-20 mb-0">
                  Energistically transition interoperable resources with
                  principle-centered metrics. Enthusiastically functional
                  process improvements.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AiCompanyInfocardLarge;
